import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';

import FileFolderSelectionModal from '../../../components/Files/FileFolderSelectionModal';
import { useFileFolderSelection } from '../../../components/Providers/FileFolderSelectionProvider';
import { IndexType, SemaScanType } from '../../../Types/enums';

interface SelectSemaScanTypeStepProps {
  vectorStoreId: string;
  onNext: () => void;
}

const SelectSemaScanTypeStep: React.FC<SelectSemaScanTypeStepProps> = ({
  vectorStoreId,
  onNext,
}) => {
  const { clearSelection } = useFileFolderSelection();

  const [scanType, setScanType] = useState<SemaScanType>(SemaScanType.TWO_STEP);
  const [modalOpen, setModalOpen] = useState(false);

  const handleSelectType = (type: SemaScanType) => {
    if (type === SemaScanType.FULL) return;
    clearSelection();
    setScanType(type);
  };

  const handleOpenModal = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  const handleConfirm = useCallback(() => {
    handleCloseModal();
    onNext();
  }, [handleCloseModal, onNext]);

  return (
    <Box>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={6}>
          <Paper
            elevation={0}
            sx={{
              border: scanType === SemaScanType.TWO_STEP ? '2px solid #1976d2' : '1px solid #ccc',
              borderRadius: '8px',
              padding: 2,
              cursor: 'pointer',
              transition: 'border 0.3s',
            }}
            onClick={() => handleSelectType(SemaScanType.TWO_STEP)}
          >
            <Typography variant="subtitle1" fontWeight={600} color="#1976d2">
              SEMA 2-Step
            </Typography>
            <Typography variant="body2" mt={0.5} color="gray">
              {"SEMA's lightweight code base scan to evaluate code quality, security and risks."}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper
            elevation={0}
            sx={{
              border: '1px solid #ccc',
              borderRadius: '8px',
              padding: 2,
              color: '#999',
              backgroundColor: '#f9f9f9',
              cursor: 'not-allowed',
            }}
          >
            <Typography variant="subtitle1" fontWeight={600} color="gray">
              SEMA Full
            </Typography>
            <Typography variant="body2" mt={0.5} color="gray">
              (Coming soon)
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      <Box my={4} display="flex" justifyContent="center">
        <Button
          variant="contained"
          onClick={handleOpenModal}
          sx={{
            backgroundColor: '#0d1b66',
            marginBottom: 4,
            '&:hover': {
              backgroundColor: '#0a1552',
            },
          }}
        >
          Choose Files / Folder
        </Button>
      </Box>
      {vectorStoreId && (
        <FileFolderSelectionModal
          open={modalOpen}
          onClose={handleCloseModal}
          onConfirm={handleConfirm}
          indexId={vectorStoreId}
          indexType={IndexType.OPENAI}
        />
      )}
    </Box>
  );
};

export default SelectSemaScanTypeStep;
